namespace GeniuzPOS.AdvPromo {
    export interface PsAdvPromoHdRow {
        Id?: number;
        PromoCampaign?: string;
        PromoCampName?: string;
        PmGroupId?: string;
        PmGroupDesc?: string;
        StartPromoDate?: string;
        EndPromoDate?: string;
        PromoTimeFg?: PromoTimeFg;
        StartPromoTime?: string;
        EndPromoTime?: string;
        PromoDayFg?: PromoDayChFg;
        PromoDay?: number[];
        PromoShopFg?: PromoShopFg;
        PromoShop?: string[];
        PromoCustFg?: number;
        PromoMb?: string[];
        PromoApproveFg?: number;
        PromoStatus?: number;
        CreateBy?: string;
        CreateDate?: string;
        UpdateBy?: string;
        UpdateDate?: string;
        ApproveBy?: string;
        Approvedate?: string;
        ActiveBy?: string;
        Activedate?: string;
        VenderSharing?: number;
    }

    export namespace PsAdvPromoHdRow {
        export const idProperty = 'PmGroupId';
        export const nameProperty = 'PmGroupId';
        export const localTextPrefix = 'AdvPromo.PsAdvPromoHd';
        export const lookupKey = 'AdvPromo.PsAdvPromoHd';

        export function getLookup(): Q.Lookup<PsAdvPromoHdRow> {
            return Q.getLookup<PsAdvPromoHdRow>('AdvPromo.PsAdvPromoHd');
        }
        export const deletePermission = '4ADVANCED_PROMOTION:เพิ่มโปรโมชั่น:Delete';
        export const insertPermission = '4ADVANCED_PROMOTION:เพิ่มโปรโมชั่น:Modify';
        export const readPermission = '4ADVANCED_PROMOTION:เพิ่มโปรโมชั่น:View';
        export const updatePermission = '4ADVANCED_PROMOTION:เพิ่มโปรโมชั่น:Modify';

        export declare const enum Fields {
            Id = "Id",
            PromoCampaign = "PromoCampaign",
            PromoCampName = "PromoCampName",
            PmGroupId = "PmGroupId",
            PmGroupDesc = "PmGroupDesc",
            StartPromoDate = "StartPromoDate",
            EndPromoDate = "EndPromoDate",
            PromoTimeFg = "PromoTimeFg",
            StartPromoTime = "StartPromoTime",
            EndPromoTime = "EndPromoTime",
            PromoDayFg = "PromoDayFg",
            PromoDay = "PromoDay",
            PromoShopFg = "PromoShopFg",
            PromoShop = "PromoShop",
            PromoCustFg = "PromoCustFg",
            PromoMb = "PromoMb",
            PromoApproveFg = "PromoApproveFg",
            PromoStatus = "PromoStatus",
            CreateBy = "CreateBy",
            CreateDate = "CreateDate",
            UpdateBy = "UpdateBy",
            UpdateDate = "UpdateDate",
            ApproveBy = "ApproveBy",
            Approvedate = "Approvedate",
            ActiveBy = "ActiveBy",
            Activedate = "Activedate",
            VenderSharing = "VenderSharing"
        }
    }
}
